import { getOperatorPermissions } from '@/services/posOperatorService';

export const QUOTATION_ACTION_PERMISSIONS = Object.freeze({
  list: ['com.openbravo.pos.sales.JPanelTicketSales'],
  create: ['com.openbravo.pos.sales.JPanelTicketSales'],
  detail: ['sales.EditLines'],
  edit: ['sales.EditLines'],
  delete: ['sales.EditLines'],
  convert: ['sales.EditLines'],
  print: ['sales.PrintTicket'],
});

/** Replica en UI los permisos por endpoint de promociones del backend. */
export const PROMOTION_ACTION_PERMISSIONS = Object.freeze({
  list: ['itpv.promotions'],
  create: ['itpv.promotions'],
  edit: ['itpv.promotions'],
  delete: ['itpv.promotions'],
  toggle: ['itpv.promotions'],
  // La caja aplica promociones sin poder administrarlas.
  apply: ['itpv.promotions', 'com.openbravo.pos.sales.JPanelTicketSales'],
});

export const OPERATOR_ROUTE_RULES = [
  { prefix: '/admin/pos', anyOf: ['com.openbravo.pos.sales.JPanelTicketSales'] },
  { prefix: '/admin/quotations', anyOf: ['com.openbravo.pos.sales.JPanelTicketSales'] },
  { prefix: '/admin/cash-closure', anyOf: ['com.openbravo.pos.panels.JPanelCloseMoney'] },
  {
    prefix: '/admin/sales',
    anyOf: [
      'com.openbravo.pos.forms.MenuSalesManagement',
      'com.openbravo.pos.sales.JPanelTicketEdits',
      'com.openbravo.pos.sales.JPanelTicketSales',
    ],
  },
  {
    prefix: '/admin/clients',
    anyOf: [
      'com.openbravo.pos.customers.CustomersPanel',
      'com.openbravo.pos.customers.CustomersPayment',
    ],
  },
  { prefix: '/admin/customer-history', anyOf: ['itpv.customer.history'] },
  { prefix: '/admin/promotions', anyOf: ['itpv.promotions'] },
  {
    prefix: '/admin/print-bridges',
    anyOf: [
      'com.openbravo.pos.panels.JPanelPrinter',
      'com.openbravo.pos.config.JPanelConfiguration',
    ],
  },
  { prefix: '/admin/settings', anyOf: ['com.openbravo.pos.config.JPanelConfiguration'] },
  { prefix: '/admin/products', anyOf: ['com.openbravo.pos.inventory.ProductsPanel'] },
  { prefix: '/admin/categories', anyOf: ['com.openbravo.pos.inventory.CategoriesPanel'] },
  {
    prefix: '/admin/inventory',
    anyOf: [
      'com.openbravo.pos.inventory.StockManagement',
      'com.openbravo.pos.inventory.ProductsWarehousePanel',
      'com.openbravo.pos.inventory.StockDiaryPanel',
    ],
  },
  { prefix: '/admin/roles-permissions', anyOf: ['com.openbravo.pos.admin.RolesPanel'] },
  { prefix: '/admin/pos-users', anyOf: ['com.openbravo.pos.admin.PeoplePanel'] },
  { prefix: '/admin/users', anyOf: ['com.openbravo.pos.admin.PeoplePanel'] },
  {
    prefix: '/admin/reports',
    predicate: permission => permission.startsWith('/com/openbravo/pos/reports/'),
  },
];

export const hasAnyOperatorPermission = (required = [], permissions = getOperatorPermissions()) => (
  !required.length || required.some(permission => permissions.includes(permission))
);

/** Replica en UI los permisos por endpoint de cotizaciones del backend. */
export const canQuotationAction = (action, permissions = getOperatorPermissions()) => {
  const required = QUOTATION_ACTION_PERMISSIONS[action];
  return Array.isArray(required) && hasAnyOperatorPermission(required, permissions);
};

export const canPromotionAction = (action, permissions = getOperatorPermissions()) => {
  const required = PROMOTION_ACTION_PERMISSIONS[action];
  return Array.isArray(required) && hasAnyOperatorPermission(required, permissions);
};

export const canAccessOperatorPath = (path, permissions = getOperatorPermissions()) => {
  if (path === '/dashboard' || path === '/admin/dashboard') return true;
  const rule = OPERATOR_ROUTE_RULES.find(entry => path === entry.prefix || path.startsWith(`${entry.prefix}/`));
  if (!rule) return true;
  return rule.predicate
    ? permissions.some(rule.predicate)
    : hasAnyOperatorPermission(rule.anyOf, permissions);
};
